import { render } from "./MerchantOrdersListPage.vue?vue&type=template&id=ab453c0c&ts=true"
import script from "./MerchantOrdersListPage.vue?vue&type=script&lang=ts"
export * from "./MerchantOrdersListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__